var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-categories_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-categories_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-categories_svg__st0",
    d: "M9.4 11.4H3.7c-1.1 0-2-.9-2-2V3.7c0-1.1.9-2 2-2h5.7c1.1 0 2 .9 2 2v5.7c0 1.1-.9 2-2 2zM3.7 3.7v5.7h5.7V3.7H3.7zM20.3 11.4h-5.7c-1.1 0-2-.9-2-2V3.7c0-1.1.9-2 2-2h5.7c1.1 0 2 .9 2 2v5.7c0 1.1-.9 2-2 2zm-5.7-7.7v5.7h5.7V3.7h-5.7zM9.4 22.3H3.7c-1.1 0-2-.9-2-2v-5.7c0-1.1.9-2 2-2h5.7c1.1 0 2 .9 2 2v5.7c0 1.1-.9 2-2 2zm-5.7-7.7v5.7h5.7v-5.7H3.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-categories_svg__st0",
    d: "M20.3 22.3h-5.7c-1.1 0-2-.9-2-2v-5.7c0-1.1.9-2 2-2h5.7c1.1 0 2 .9 2 2v5.7c0 1.1-.9 2-2 2zm0-2v1-1zm-5.7-5.7v5.7h5.7v-5.7h-5.7z",
    opacity: 0.5
  })));
}

export default SvgIconCategories;